<!--添加奖励-单个的，没有派奖模式、奖品数量-->
<template>
  <div class="f-reward">
    <div class="reward-content" v-if="gift != null">
      <div class="form-region">
        <div class="form-region-title">
          <span class="text">添加好友奖励</span>
          <span class="del" @click="removeGift()"
            ><van-icon name="delete" />重置</span
          >
        </div>
        <div class="form-region-row">
          <span class="title">奖品名称</span>
          <input
            class="input"
            type="text"
            v-model="gift.name"
            maxlength="20"
            placeholder="不超过20个字"
          />
        </div>
        <!-- <div class="form-region-row">
          <span class="title">奖品数量</span>
          <input
            class="input"
            type="number"
            v-model="gift.amount"
            placeholder="最多可以发出去多少个奖励"
          />
        </div> -->

        <div class="form-region-row pointer" @click="editReward()">
          <span class="title">奖励内容</span>
          <div style="color: #212121" class="input" v-if="gift.formid">
            内容已经设置，点击修改
          </div>
          <div class="input" v-else>
            点击设置奖励的具体内容
          </div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>

    <van-action-sheet
      v-model="gifttype_show"
      :actions="gifttype_actions"
      @select="gifttype_selevent"
    />
    <van-popup
      v-model="reward.SettleShow"
      position="bottom"
      :style="{ height: '100%', width: '100%' }"
    >
      <lu_formedit
        v-if="reward.SettleShow"
        :formtype="3"
        :defaultfields="reward.rewardtype"
        v-model="reward.nowitem.content.formid"
        :cc="reward.editcc"
      ></lu_formedit>
    </van-popup>
    <van-popup
      v-model="reward.rewardTypeShow"
      round
      position="bottom"
      closeable
    >
      <lu_rewardtype :cc="reward.typecc"></lu_rewardtype>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import lu_formedit from "../form/edit";
import lu_rewardtype from "./RewardType";
var event = "change" + new Date().valueOf();
import { Dialog } from "vant";

export default {
  model: {
    prop: "parentGift", // prop说:我要将value1作为该组件被使用(被父组件调用)时,v-model能取到的值
    event: event, // event说:我emit(触发)change的时候，参数的值就是父组件v-model收到的值。
  },
  props: ["parentGift"],
  name: "f-edit",
  data() {
    return {
      reward: {
        SettleShow: false,
        editcc: {
          close: function() {},
        },
        nowitem: {
          action: "",
          content: { formid: 0 },
        },
        rewardTypeShow: false,
        rewardtype: 1,
        typecc: {
          close: function() {},
        },
      },
      gifttype_index: 0,
      gifttype_show: false,
      gifttype_actions: [
        { name: "按排名获奖", id: 1 },
        { name: "按完成邀请人数获奖", id: 2 },
      ],

      text: "",
      gift: null,
    };
  },
  watch: {
    shareGift: {
      handler(val, oldval) {
        // console.log("shareGift", val);
        this.$emit(event, val);
      },
      deep: true,
    },
    gift: {
      handler(val, oldval) {
        // console.log("shareGift", val);
        this.$emit(event, val);
      },
      deep: true,
    },

  },
  methods: {
    editReward() {
      var t = this;
      console.log("t.gift", t.gift);
      t.reward.nowitem.content = {
        formid: t.gift.formid,
        rewardtype: t.gift.rewardtype || 1,
      };

      t.reward.rewardtype = t.gift.rewardtype || 1;
      if (t.reward.nowitem.content && t.reward.nowitem.content.formid)
        t.reward.SettleShow = true;
      else t.reward.rewardTypeShow = true;
    },
    rewardSettleEnter(formid, rewardtype) {
      var t = this;
      if (formid) {
        t.reward.nowitem.content.formid = parseInt(formid);
        t.reward.nowitem.content.rewardtype = rewardtype || 1;
        t.gift.formid = parseInt(formid);
        t.gift.rewardtype = parseInt(rewardtype || 1);
        console.log("t.reward.nowitem.content", t.reward.nowitem.content);
      }

      t.reward.SettleShow = false;
    },
    //打开选项
    gifttype_showevent(index) {
      this.gifttype_index = index;
      this.gifttype_show = true;
    },
    //选择某个奖项
    gifttype_selevent(item) {
      this.shareGift[this.gifttype_index].type = item.id;
      this.shareGift[this.gifttype_index].typename = item.name;
      this.gifttype_show = false;
    },
    selMoudle() {},

    removeGift() {
      Dialog.confirm({
        title: "提示",
        message: "您确认要重置奖励内容吗？",
      })
        .then(() => {
          this.gift = {
            name: "",
            formid: 0,
          };
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  components: { lu_formedit, lu_rewardtype },
  computed: {},
  created() {
    var t = this;
    console.log("t.parentGift", t.parentGift);
    t.reward.editcc.close = function(formid, rewardtype) {
      console.log("formid", formid);
      t.reward.SettleShow = false;
      t.rewardSettleEnter(formid, rewardtype);
    };
    t.reward.typecc.close = function(type, rewardtype) {
      t.reward.nowitem.content.formid = 0;
      t.reward.nowitem.content.rewardtype = rewardtype || 1;
      t.reward.rewardtype = type;
      t.reward.SettleShow = true;
      t.reward.rewardTypeShow = false;
    };
    if (t.parentGift) t.gift = t.parentGift;
    else
      t.shareGift = {
        name: "",
        formid: 0,
      };
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import "../../../static/scss/var";
.form-fields-add {
  border: 0;
  @include flex;
  @include align_items_center;
  @include justify_content_flex_center;
  margin: 10px auto;
  color: $vm_fontcolor_minor2;
  // font-weight: bold;
  font-size: 14px;
  width: 120px;
  height: 36px;
  border-radius: 18px;
  text-align: center;
  background-color: $vm_bg_minor;
  background-color: #fff;
  color: $vm_bg_main;
  box-shadow: 5px 5px 15px rgba($color: #ccc, $alpha: 0.3);
  border: 1px solid #f7f7f7;
  // opacity: .6;
  // background-color: #efefef;
  .van-icon {
    font-size: 20px;
    margin-right: 3px;

    // color: #fff;
    // color: #666;
  }
}
.reward-content {
  background: #f7f7f7;
  height: calc(100vh - 56px);
}
.form-region {
  margin-bottom: vw(25);
  padding: vw(20) vw(25);
  background-color: #fff;
  .form-region-title {
    font-weight: bold;
    font-size: 20px;
    color: #000;
    padding: 10px 0;
    @include flex;
    @include align_items_center;
    span.text {
      @include flex_1;
    }
    span.del {
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      height: 25px;
      @include flex;
      @include align_items_center;
      padding: 0 10px;
      // background: $vm_fontcolor_warning;
      background: #999;
      border-radius: 23px;
      color: #fff;
    }
    .van-switch {
    }
  }
  .pointer {
    cursor: pointer;
    input {
      cursor: pointer;
    }
  }
  .form-region-row {
    @include flex;
    @include align_items_center;
    height: 60px;
    font-size: 15px;
    border-bottom: 1px #efefef solid;
    color: $vm_fontcolor_main;
    .title {
    }
    .input {
      @include flex_1;
      border: 0;
      text-align: right;
      margin-left: 10px;
      border-radius: 3px;
    }
    .tags {
      width: 0;
      @include flex;
      .lqizi {
        @include flex_1;
      }
    }
    div.input {
      color: #999;
      // text-align: right;

      .tag {
        font-size: 12px;
        background-color: $vm_bg_main;
        color: #fff;
        margin-right: 5px;
        border-radius: 3px;
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
      }
      .more {
        padding: 3px 10px;
        margin-right: 5px;
        border-radius: 3px;
        font-size: 12px;
        background-color: #fff;
        color: #212121;
        border: 1px solid #ccc;
      }

      .swiper-container {
        // overflow: inherit;
      }
    }
    .van-icon,
    .van-switch {
      font-size: vw(24);
      margin-left: vw(10);
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
